import type { CurrencyFormatSettings } from '../../../../../types/Configuration';

const selectCurrencyFormat = (currencyConfig: CurrencyFormatSettings | undefined, code: string, language: string) =>
  currencyConfig?.currencySpecificFormats?.reduce((acc, currency) => {
    if (currency.currencyCode === code) {
      return currency.languageSpecificFormats?.find((format) => format.language === language) ?? currency;
    }
    return acc;
  }, null);

export default selectCurrencyFormat;
